import { InputLabel, Skeleton, TextField, styled } from "@mui/material";
import { paletteTheme } from "utils/Theme";
import { blockInvalidChar } from "utils/common";

const BootstrapInput = styled(TextField)(({ theme }) => ({
  backgroundColor: "#ffffff",
  borderRadius: 8,
  "label + &": {
    marginTop: "20px",
  },
  "& .MuiOutlinedInput-root": {
    borderRadius: 8,
  },
  // "& .MuiOutlinedInput-notchedOutline": {
  //   border: "1px solid",
  //   borderColor: "#006580",
  // },
  "& .MuiInputBase-input": {
    borderRadius: 8,
    position: "relative",
    fontSize: 12,
    padding: "12px",
    "&::placeholder": {
      textTransform: "capitalize",
    },
    transition: theme.transitions.create([
      "border-color",
      "background-color",
      "box-shadow",
    ]),
  },
  "& .MuiFormHelperText-root ": {
    margin: 0,
    color: theme.palette.error.main,
    fontWeight: 400,
  },
}));

const GKTextField = (props) => {
  const { inputLabel, id, name, loading, requiredField, type, placeholder } =
    props;

  return (
    <>
      {inputLabel && (
        <InputLabel
          style={{
            color: "#000000",
            fontSize: "18px",
            fontFamily: "Inter !important",
            textTransform: "capitalize",
          }}
          shrink
          htmlFor={name || id}
        >
          {inputLabel}
          {requiredField && (
            <span
              style={{
                color: paletteTheme.palette.error.main,
              }}
            >
              *
            </span>
          )}
        </InputLabel>
      )}
      {loading ? (
        <Skeleton
          animation="wave"
          variant="rectangular"
          sx={{
            marginTop: "20px",
            height: 46,
            borderRadius: 2,
          }}
        />
      ) : (
        <BootstrapInput
          placeholder={placeholder || inputLabel || "Enter"}
          onKeyDown={blockInvalidChar}
          onWheel={(e) => e.target.blur()}
          autoComplete="off"
          fullWidth
          type={type || ""}
          {...props}
        />
      )}
    </>
  );
};

export default GKTextField;
